<template>
  <base-page-component>

    <div>
      <b-card>
        <!--<b-col md="5" v-if="validateErrors.items!==undefined && validateErrors.items.length > 0">
          <b-row>
            <b-col md="12">
              <b-list-group style="min-width:100%">
                <b-list-group-item class="py-2" variant="danger" v-for="err in validateErrors.items" :key="err.id"> {{ err.msg }} </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
          <br />
        </b-col>-->
        <b-col md="7">
          <b-form-group class="my-1">
            <b-input-group>
              <b-input-group-append>
                <div class="mr-2">
                  <label for="startDate">Start Date</label>
                  <!--<dx-text-box v-model="startDate"
                                />-->
                  <dx-date-box v-model="startDate"
                               v-validate="{ required: true, date_format: 'MM/dd/yyyy', date_between:['01/01/1900','01/01/2100'] }"
                               dateSerializationFormat="MM/dd/yyyy"
                               @keydown.native="StartSearch"
                               name="Start Date"
                               :isValid="HasError('Start Date')"
                               :validationError="GetError('Start Date')"
                               ></dx-date-box>
                </div>
                <div class="mr-2">
                  <label for="endDate">End Date</label>
                  <dx-date-box
                               v-model="endDate"
                               v-validate="{ required: true, date_format: 'MM/dd/yyyy', date_between:['01/01/1900','01/01/2100'] }"
                               dateSerializationFormat="MM/dd/yyyy"
                               @keydown.native="StartSearch"
                               name="End Date"
                               :isValid="HasError('End Date')"
                               :validationError="GetError('End Date')"
                               ></dx-date-box>
                </div>
                <div class="mr-2">
                  <label for="accountNumber">Account Number</label>
                  <dx-text-box v-model="accountNumber"
                               v-validate="{required: true}"
                               @keydown.native="StartSearch"
                               name="Account Number"
                               :isValid="HasError('Account Number')"
                               :validationError="GetError('Account Number')"
                               />
                </div>
                <div class="mr-2 mt-4">
                  <b-form-group v-slot="{ ariaDescribedby }" @change="fetchData">
                    <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="filter-radios" value="0">None</b-form-radio>
                    <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="filter-radios" value="1">Group By States</b-form-radio>
                    <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="filter-radios" value="2">Group By Users</b-form-radio>
                  </b-form-group>
                </div>
                <div class="mr-2 mt-4">
                  <b-btn class="btn btn-success text-white ml-2" @click="fetchData">
                    <i class="fa fa-refresh" title="Refresh"></i> <strong class="text-white">Refresh</strong>
                  </b-btn>
                </div>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <br />
        <b-col md="12">
          <!-- Main table element -->
          <b-table :items="FilteredRecords" :fields="FilteredGridFields" hover striped bordered small :current-page="currentPage" :sort-compare="onNewSort" :per-page="perPage" show-empty>

          </b-table>
        </b-col>

        <b-col md="12">
          <nav>
            <b-pagination :total-rows="getRowCount()" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next"></b-pagination>
          </nav>
        </b-col>

      </b-card>
    </div>

  </base-page-component>
</template>

<script>
import axios from 'axios'
import loading from 'vue-full-loading'
import moment from 'moment'
import { setTimeout } from 'timers'
import { basePageMixin } from '@/mixins/basePageMixin'
import {
  DxDateBox,
  DxCalendarOptions,
  DxDisplayFormat
} from 'devextreme-vue/ui/date-box'

import { DxTextBox } from 'devextreme-vue'

export default {
  components: {
    loading,
    DxDateBox,
    DxCalendarOptions,
    DxDisplayFormat,
    DxTextBox
  },
  mixins: [basePageMixin],
  created () {
    let self = this
    setTimeout(function () {
      self.toggleloader(false)
    }, 100)
  },
  filters: {
    formatDate: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        return m.add(moment().utcOffset(), 'm').format('MM/DD/yyyy hh:mm:ss a')
      }
      return ''
    },
    formatAccessDisplay: function (accessBool) {
      var display = 'No'
      if (accessBool) {
        display = 'Yes'
      }
      return display
    }
  },
  data () {
    return {
      accountNumber: '',
      startDate: moment().add(-1, 'months').format('MM/DD/YYYY'),
      endDate: moment().format('MM/DD/YYYY'),
      selected: '0',

      gridfields: [
        { key: 'DealershipName', label: 'Dealership Name', sortable: true },
        { key: 'Account', label: 'Account', sortable: true },
        { key: 'UserName', label: 'User Name', sortable: true },
        { key: 'Market', label: 'State', sortable: true },
        { key: 'ScanType', label: 'Scan Type', sortable: true },
        { key: 'RecordCount', label: 'Scans', sortable: true }
      ],
      items: [],
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
      onNewSort (a, b, key) {
        if (['created_ts'].indexOf(key) !== -1) {
          switch (key) {
            // case 'FUTUREUNKNOW':
            //  console.log(`${JSON.stringify(new Date())} (typeof a) ${(typeof a[key])} [${JSON.stringify(a[key])}] (typeof a) ${(typeof a[key])} [${JSON.stringify(a[key])}]`);
            //  break;
            case 'created_ts':
              var a1 = moment(a[key])
              var b1 = moment(b[key])

              if (a1.isValid() && b1.isValid()) {
                if (a1.isSame(b1)) {
                  return 0
                }
                if (a1.isAfter(b1)) {
                  return 1
                }
                return -1
              } else {
                if (a1.isValid()) {
                  return 1
                }
                if (b1.isValid()) {
                  return -1
                }
              }
              return 0
          }
        } else {
          if (typeof a[key] === 'number' && typeof b[key] === 'number') {
            // If both compared fields are native numbers
            return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
          } else if (typeof a[key] === 'boolean' && typeof b[key] === 'boolean') {
            let a1 = ((a[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            let b1 = ((b[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            return a1 < b1 ? 1 : (a1 > b1 ? -1 : 0)
          } else {
            let a1 = (a[key] + '')
            let b1 = (b[key] + '')
            return (a1).localeCompare(b1)
          }
        }
      }
    }
  },
  methods: {
    GetError (param) {
      let self = this
      let err = self.validateErrors.first(param)
      if (err !== undefined) {
        return { message: err }
      }
      return undefined
    },
    HasError (param) {
      let self = this
      if (self.validateErrors.first(param) !== undefined) {
        return false
      }
      return true
    },
    getRowCount () {
      let self = this
      if (self.FilteredRecords !== undefined) {
        return self.FilteredRecords.length
      }
      return 0
    },
    StartSearch (event) {
      let self = this
      if (event.key === 'Enter') {
        setTimeout(function () {
          self.fetchData()
        }, 100)
      }
    },
    dateToUTC(date) {
      var m = moment(date)
      if (m.isValid()) {
        return moment(date).utc().format('MM/DD/YYYY hh:mm:ss a')
      }
      return ''
    },
    fetchData () {
      var self = this
      this.$validator.validateAll().then((result) => {
        setTimeout(function () {
          if (result) {
            self.toggleloader(true)
            var obj = {
              accountNumber: self.accountNumber,
              // NOTE: we're not converting to UTC because we want to align with the billing cycle, which stops/starts at midnight UTC
              startDate: self.startDate,
              endDate: self.endDate,
              groupByStates: self.selected === '1',
              groupByUsers: self.selected === '2'
            }

            axios.post('/api/Reports/GetUsageReport', obj)
              .then(response => {
                self.items = response.data
                self.totalRows = self.items.length
                self.showInformation('Data has been loaded')
              })
              .catch(error => {
                self.handleError(error)
              }).then(() => {
                self.toggleloader(false)
              })
          }
        }, 100)
      })
    }
  },
  computed: {
    FilteredGridFields: function () {
      var self = this
      return self.gridfields
        .filter(u => self.selected === '1' ? true : u.key !== 'Market')
        .filter(u => self.selected === '2' ? true : u.key !== 'UserName')
    },
    FilteredRecords: function () {
      var self = this
      return self.items

      // if (this.boolLoading) {
      //  return []
      // } else {
      //  if (this.filterShowActiveUsersOnly) {
      //    return this.items.filter(u => !u.is_disabled)
      //  } else {
      //    return this.users
      //  }
      // }
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = false
  }
}
</script>

<style type="text/css">
  .dx-overlay-content.dx-resizable {
    max-width: unset !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/UsageReport.vue